import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  TextField,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

const TerminateModal = ({
  classes,
  txnOpps,
  isOpen,
  setIsOpen,
  terminateTasks,
  singleOpp // Used on property UW HeaderImage
}) => {
  const [selectedReason, setSelectedReason] = useState('');

  function handleTerminate() {
    terminateTasks(selectedReason);
    setSelectedReason('');
  }

  function handleClose(e, reason) {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setIsOpen(false);
    setSelectedReason('');
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth='sm'>
      <DialogTitle disableTypography={true}>
        <Typography variant={'h6'}>
          <span>{`Terminate Transaction ${singleOpp ? 'Opportunity' : 'Opportunities'}`}</span>
        </Typography>
        {!singleOpp &&
          <Typography variant='body1' className={classes.caption}>{`${txnOpps?.length} task${txnOpps?.length > 1 ? 's' : ''} selected`}</Typography>
        }
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent className={classes.content}>
        <TextField
          label='Termination Reason'
          className={classes.formControl}
          value={selectedReason}
          onChange={e => setSelectedReason(e.target.value)}
          select
        >
          <MenuItem value='Descriptives Buy Box Cut'>Descriptives Buy Box Cut</MenuItem>
          <MenuItem value='Legal Cut'>Legal Cut</MenuItem>
          <MenuItem value="Inspection Cut">Inspection Cut</MenuItem>
          <MenuItem value="Pre-Screen No Bid Cut">Pre-Screen No Bid Cut</MenuItem>
          <MenuItem value="Underwrite No Bid Cut">Underwrite No Bid Cut</MenuItem>
          <MenuItem value='Duplicate'>Duplicate</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>Cancel</Button>
        <Button variant='contained' className={classes.redDialogButton} onClick={() => handleTerminate()} disabled={!selectedReason}>Terminate</Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = theme => ({
  caption: {
    marginTop: 8
  },
  content: {
    paddingBottom: 8
  },
  redDialogButton: {
    color: 'white',
    backgroundColor: theme.palette.red.main,
    '&:hover': {
      backgroundColor: theme.palette.red.dark
    }
  },
  formControl: {
    width: '80%',
    marginBottom: 8
  },
  inspectionMessage: {
    color: 'red'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

export default withStyles(styles)(TerminateModal);